export const createInvoicesLocation = "/accounting/createinvoices";
